import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue";
import _imports_0 from '@/assets/addCurrentAccountBenefits.png';
const _hoisted_1 = {
    key: 0,
    class: "linkPage"
};
const _hoisted_2 = { class: "linkActions anchor-bottom" };
const _hoisted_3 = ["href"];
const _hoisted_4 = { class: "benefitsDrawer" };
const _hoisted_5 = ["href"];
import { ref, getCurrentInstance, onBeforeUnmount, onMounted, watch } from 'vue';
import { useRouter } from 'vue-router';
import { DotLottie } from '@lottiefiles/dotlottie-web';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import { useBanking } from '@/composables/useBanking';
import SimpleDrawerPanel from './elements/SimpleDrawerPanel.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
import MGButton from './elements/MGButton.vue';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'LinkOpenBankingAccountPage',
    setup(__props) {
        const router = useRouter();
        const state = useAppState();
        useAuth();
        const { getCustomer, setSignupStage } = useCustomer();
        const { getOpenBankingLinkUrl } = useBanking();
        const cookies = getCurrentInstance()?.appContext.config.globalProperties.$cookies;
        const benefitsOpen = ref(false);
        /* Bundled with the app rather than fetched from LottieFiles' CDN, so it works offline */
        DotLottie.setWasmUrl(require('@lottiefiles/dotlottie-web/dotlottie-player.wasm'));
        const lottieCanvas = ref(null);
        let player = null;
        /* The canvas only appears once the customer has loaded, so start the animation then */
        watch(lottieCanvas, (canvas) => {
            player?.destroy();
            player = canvas ? new DotLottie({ canvas, src: require('@/assets/onboarding/link-account-animation.lottie'), autoplay: true, loop: true }) : null;
        });
        onBeforeUnmount(() => player?.destroy());
        function onLoad() {
            getCustomer(() => setSignupStage('Complete'));
        }
        function continueNext(linking) {
            if (linking) {
                cookies?.set('waitBank', true);
            }
            router.replace({ path: '/signin/allset' });
        }
        onMounted(() => {
            onLoad();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, {
                    title: "",
                    border: 0,
                    transparent: true
                }),
                _createVNode(CustomerLoadWait, {
                    customer: _unref(state).customer
                }, null, 8, ["customer"]),
                (_unref(state).customer)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createElementVNode("canvas", {
                            ref_key: "lottieCanvas",
                            ref: lottieCanvas,
                            class: "linkIllustration"
                        }, null, 512),
                        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "linkHeading" }, [
                            _createElementVNode("h1", null, "Unlock more with Money Guided"),
                            _createElementVNode("p", null, "Securely connecting your bank accounts allows you to spot savings and see the full picture with balances & spending.")
                        ], -1)),
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("a", {
                                class: "linkCta",
                                href: _unref(getOpenBankingLinkUrl)(_unref(state).customer.id),
                                target: "_blank"
                            }, [
                                _createVNode(MGButton, {
                                    class: "ctaButton",
                                    text: "Connect with OPEN BANKING",
                                    noCaps: true,
                                    arrow: true,
                                    fullWidth: true,
                                    icon: require('@/assets/open-banking-bg.png'),
                                    onClick: _cache[0] || (_cache[0] = ($event) => (continueNext(true)))
                                }, null, 8, ["icon"])
                            ], 8, _hoisted_3),
                            _createVNode(MGButton, {
                                class: "ctaButton",
                                text: "I'll do this later",
                                noCaps: true,
                                outline: true,
                                fullWidth: true,
                                onClick: _cache[1] || (_cache[1] = ($event) => (continueNext(false)))
                            }),
                            _createVNode(MGButton, {
                                class: "securityCta",
                                text: "See all benefits",
                                noCaps: true,
                                fullWidth: false,
                                transparent: true,
                                onClick: _cache[2] || (_cache[2] = ($event) => (benefitsOpen.value = true))
                            })
                        ])
                    ]))
                    : _createCommentVNode("", true),
                (_unref(state).customer)
                    ? (_openBlock(), _createBlock(SimpleDrawerPanel, {
                        key: 1,
                        modelValue: benefitsOpen.value,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((benefitsOpen).value = $event)),
                        title: "See all benefits",
                        closeButton: true,
                        divider: false
                    }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_4, [
                                _cache[7] || (_cache[7] = _createElementVNode("p", { class: "benefitsIntro" }, "You can bring your current, credit & savings accounts into Money Guided in two secure ways:", -1)),
                                _cache[8] || (_cache[8] = _createElementVNode("img", {
                                    src: _imports_0,
                                    alt: "Open Banking compared with offline accounts",
                                    class: "benefitsImage"
                                }, null, -1)),
                                _createElementVNode("a", {
                                    class: "linkCta",
                                    href: _unref(getOpenBankingLinkUrl)(_unref(state).customer.id),
                                    target: "_blank"
                                }, [
                                    _createVNode(MGButton, {
                                        text: "Connect with OPEN BANKING",
                                        noCaps: true,
                                        arrow: true,
                                        fullWidth: true,
                                        icon: require('@/assets/open-banking-bg.png'),
                                        onClick: _cache[3] || (_cache[3] = ($event) => (continueNext(true)))
                                    }, null, 8, ["icon"])
                                ], 8, _hoisted_5),
                                _createVNode(MGButton, {
                                    text: "I'll do this later",
                                    noCaps: true,
                                    outline: true,
                                    arrow: true,
                                    fullWidth: true,
                                    onClick: _cache[4] || (_cache[4] = ($event) => (continueNext(false)))
                                })
                            ])
                        ]),
                        _: 1
                    }, 8, ["modelValue"]))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
